module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /Users/Mee/Desktop/annual-summary-2017/node_modules/core-js/library/modules/_redefine.js
// module id = MbDV
// module chunks = 0